import React from 'react';

import type { AIEventsInstrumentationConfig } from '@atlassian/ai-analytics';
import { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';

import { Miniplayer } from '../../miniplayer/Miniplayer';

const aiAnalyticsConfig: AIEventsInstrumentationConfig = {
	product: 'confluence',
	subproduct: 'confluence',
	source: 'page',
	aiFeatureName: 'aiAudioBriefing',
	proactiveGeneratedAI: 0,
	userGeneratedAI: 1,
};

export const AudioBriefingsPopupListenPanel = () => {
	return (
		<AIEventsInstrumentationProvider config={aiAnalyticsConfig}>
			<Miniplayer showTimeIndicator />
		</AIEventsInstrumentationProvider>
	);
};
